import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { AutocompleteComponent, DialogResultTypes, HowdenAlertService, IDialogResult, UIBlockerService } from '@howdeniberia/core-front';
import { ILocality } from 'src/app/core/models/api';
import { ILocalityService } from 'src/app/core/services/api/locality';
import { IMapService } from 'src/app/core/services/api/map';
import { IRisksDataMapService } from 'src/app/core/services/core';
import { FileUtils } from 'src/app/shared/utils';
import { SubSink } from 'subsink';
import { DownloadReportMapper } from '../../mappers';
import { DownloadReportViewModel } from '../../models';

@Component({
  selector: 'howden-download-report',
  templateUrl: './download-report.component.html',
  styleUrls: ['./download-report.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInput,
    MatLabel,
    MatFormField,
    MatButton,
    AutocompleteComponent,
    MatCheckboxModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose
  ]
})
export class DownloadReportComponent implements OnInit, OnDestroy {
  dialogRef = inject<MatDialogRef<DownloadReportComponent>>(MatDialogRef);
  private alertSrv = inject(HowdenAlertService);
  private uiBlockerSrv = inject(UIBlockerService);
  private localitySrv = inject(ILocalityService);
  private mapSrv = inject(IMapService);
  private dataRiskMapSrv = inject(IRisksDataMapService);

  model = new DownloadReportViewModel();

  private _subscriptions = new SubSink();

  ngOnInit() {
    this.uiBlockerSrv.block();

    this._subscriptions = this.dataRiskMapSrv.getMapImageBase64Emitter().subscribe((data: string) => {
      this.model.mapImageBase64 = data;
    });

    this.localitySrv.getLocalities().subscribe((localities: ILocality[]) => {
      this.model.localities = localities;
      //Cargamos la información del mapa
      DownloadReportMapper.mapForDownload(this.dataRiskMapSrv.getDataRiskMap(null), this.model);
      this.uiBlockerSrv.unblock();
    });
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }

  createAndDownloadReport() {
    this.uiBlockerSrv.block();

    if (this.model.mapImageBase64 === '') {
      const title: string = $localize`: @@app.risk-map.download-report.result.error.no-image.title:Error`;
      const message: string = $localize`: @@app.risk-map.download-report.result.error.no-image.message:No se ha podido cargar la imagen del mapa, por favor cierre el dialogo de descarga y vuelva a intentarlo`;
      this.alertSrv.error(title, message);
      return;
    }

    const map = DownloadReportMapper.mapForSave(this.model);
    const request = this.dataRiskMapSrv.getDataRiskMap(map);

    this.mapSrv.generateReport(request).subscribe(
      {
        next: (blob: Blob) => {
          this.uiBlockerSrv.unblock();
          if (!blob) {
            const title: string = $localize`: @@app.risk-map.download-report.result.error.title:Error`;
            const message: string = $localize`: @@app.risk-map.download-report.result.error.message:Se ha producido un error al generar el informe`;
            this.alertSrv.error(title, message);
          } else {
            this.dataRiskMapSrv.setAlreadySaved(true);
            const attachName = FileUtils.formatFilename('RiskMap', 'pdf');
            FileUtils.downloadFile(
              attachName,
              blob
            );
            this.dialogRef.close({ result: DialogResultTypes.OK } as IDialogResult<void>);
          }
        }
      }
    );
  }
}
